export default (params) => ({
  trigger: {
    name: 'order_block_summary.remove_from_wishlist',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'remove_item',
      params: {
        sub_feature: null,
        list: 'wishlist',
      },
    },
  },
});
